import { FetchRequest } from './fetch_request'
import { FetchResponse } from './fetch_response'
import { RequestInterceptor } from './request_interceptor'
import { get, post, put, patch, destroy } from './verbs'

export { FetchRequest, FetchResponse, RequestInterceptor, get, post, put, patch, destroy }



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rails/request.js/src/index.js
// module id = 1010
// module chunks = 3 6 8